module.exports = __webpack_public_path__ + "static/img/ex_logo_21.2c4247f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ex/ex_logo_21.jpg
// module id = OB46
// module chunks = 0